import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

const UnorderedListItem = ({ fields }) => (
  <li data-testid={fields.testid?.value}>
    <Text field={fields.text} />
  </li>
);

export default UnorderedListItem;
